<template>
  <div class="main-header__container">
    <button
      v-if="isAuthenticated"
      class="main-header__menu-trigger"
      @click="drawer = !drawer"
    >
      <v-icon v-text="'menu'" />
    </button>

    <v-navigation-drawer
      v-if="isAuthenticated"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <div class="drawer-menu__profile">
        <div class="drawer-menu__profile__avatar" :style="`background-image: url('${currentUser.fileAvatar}')`" />
        <h1 v-text="currentUser.name" />
        <h2 v-text="currentUser.role" />
      </div>
      <ul class="drawer-menu__list">
        <router-link
          tag="li"
          v-for="item in items"
          :key="item.action"
          :to="'/' + item.action"
        >
          <v-icon>{{ item.icon }}</v-icon>
          {{ item.title }}
        </router-link>
      </ul>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MainHeader',
  data () {
    return {
      drawer: true,
      clipped: false,
      btnLogoutLoading: false,
      btnLogoutDisabled: false,
      formErrors: null,
      items: [
        {
          icon: 'home',
          action: 'home',
          title: 'Home'
        },
        {
          icon: 'menu',
          action: 'menus',
          title: 'Menus'
        },
        {
          icon: 'event',
          action: 'sections',
          title: 'Seções'
        },
        {
          icon: 'event',
          action: 'banners',
          title: 'Banners'
        },
        {
          icon: 'list_alt',
          action: 'contents',
          title: 'Conteúdo'
        },
        {
          icon: 'list_alt',
          action: 'courses',
          title: 'Cursos'
        },
        {
          icon: 'people_alt',
          action: 'users',
          title: 'Usuários'
        },
        {
          icon: 'people_alt',
          action: 'clients',
          title: 'Cadastros'
        },
        {
          icon: 'exit_to_app',
          action: 'logout',
          title: 'Logout'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(
      'authentication',
      ['isAuthenticated', 'currentUser']
    )
  },
  methods: {
    ...mapActions(
      'authentication',
      ['logout']
    )
  }
}
</script>
<style lang="stylus">
  .main-header {
    &__container {
      display: flex;
      justify-content: space-between;
      padding: 10px 26px 20px 20px;
      position: fixed;
      width: 100vw;
      z-index: 20000;
    }

    &__logo {
      width: 70px;

      &__container {
        position: absolute;
        background: white;
        top: -44px;
        padding: 50px 40px 3px;
        border-radius: 59px;
        left: calc(50vw - 150px / 2);
        box-shadow: 0 5px 9px 2px rgba(0,0,0,.12)
      }
    }
    &__calendar-trigger {
      .v-icon {
      }
    }
  }
  .drawer-menu {
    &__list {
      padding-left: 0;

      li {
        display: flex;
        cursor: pointer;
        justify-content: flex-start;
        align-items: center;
        font-size: 13px;
        color: #555;
        padding: 10px 20px 10px 35px;

        &:last-child {
          position: fixed;
          bottom: 10px;
        }

        .v-icon {
          margin-right: 10px;
          font-size: 15px;
          width: 17px;
          opacity: .5;
        }
      }
    }

    &__profile {
      padding: 20px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;

      &__avatar {
        border-radius: 50%;
        width: 130px;
        height: 130px;
        background-size: cover;
      }

      img {
        width: 50%;
        border-radius: 50%;
      }

      h1 {
        font-weight: 500;
        font-size: 25px;
        line-height: 23px;
        margin-top: 10px;
      }

      h2 {
        font-weight: 300;
        font-size: 12px;
      }
    }
  }
  @media screen and (min-width: 768px) {
    .main-header {
      &__container {
        position: relative;
        z-index: inherit;
      }
    }
  }
</style>
